__turbopack_context__.v({
  "active": "style-module-scss-module__IitrZa__active",
  "boundary-status": "style-module-scss-module__IitrZa__boundary-status",
  "centered-cell": "style-module-scss-module__IitrZa__centered-cell",
  "component": "style-module-scss-module__IitrZa__component",
  "description": "style-module-scss-module__IitrZa__description",
  "icon-check-circle": "style-module-scss-module__IitrZa__icon-check-circle",
  "icon-x-circle": "style-module-scss-module__IitrZa__icon-x-circle",
  "likely-attend-school": "style-module-scss-module__IitrZa__likely-attend-school",
  "name-column": "style-module-scss-module__IitrZa__name-column",
  "school-row": "style-module-scss-module__IitrZa__school-row",
  "school-row-details": "style-module-scss-module__IitrZa__school-row-details",
  "school-row-name": "style-module-scss-module__IitrZa__school-row-name",
  "school-row-rating": "style-module-scss-module__IitrZa__school-row-rating",
  "tab": "style-module-scss-module__IitrZa__tab",
  "tabs": "style-module-scss-module__IitrZa__tabs",
  "title-row": "style-module-scss-module__IitrZa__title-row",
  "zoocasa-theme": "style-module-scss-module__IitrZa__zoocasa-theme",
});
